<template>

<app-table empty-message="No credits have been issued.">

	<app-table-head :layout="layout">

		<app-table-column text="Date" />

		<app-table-column text="Title" />

		<app-table-column text="Amount" />

	</app-table-head>

	<app-table-body>

		<app-table-row :layout="layout" v-for="item in collection" :key="item.id">

			<app-table-cell-text :text="item.date | localDate('MM/DD/YYYY h:mma')" />

			<app-table-cell-text :text="item.title" />

			<app-table-cell-text :text="item.amount | formatMoney" />

		</app-table-row>

	</app-table-body>

	<app-table-foot :pagination="pagination" :total="total" />

</app-table>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

	data: function() {

		return {
			inline: true,
			layout: '200px 1fr 120px',
			endpoint: 'convention/billing/audit/credits'
		}

	}

}

</script>

<style scoped>

</style>